interface ErrorCodesType {
    [key: string]: string;
}

export const errorFeedbacks: ErrorCodesType = {
    "auth/invalid-email": "Bitte geben Sie eine korrekte E-Mail ein!",
    "auth/user-not-found": "Benutzer nicht gefunden...",
    "auth/wrong-password": "Falsches Passwort. Versuchen Sie es erneut...",
    "auth/empty":"Du musst deine Email und dein Passwort eingeben..."
}